import { useState } from 'react';
import { Building2, ChevronDown, Check } from 'lucide-react';
import useAuthStore from '../stores/authStore';
import { useBranding } from '../contexts/BrandingContext';

export default function TenantSelector() {
  const { tenants, currentTenant, switchTenant, tenantLoading, isPlatformAdmin } = useAuthStore();
  const { refreshBranding } = useBranding();
  const [isOpen, setIsOpen] = useState(false);

  // Don't show if only one tenant or no tenants
  if (tenants.length <= 1) {
    return null;
  }

  const handleSelect = async (tenantId) => {
    if (tenantId !== currentTenant?.id) {
      await switchTenant(tenantId);
      const orgId = useAuthStore.getState().currentTenant?.organizationId;
      if (orgId) {
        try { await refreshBranding(orgId); } catch {}
      }
    }
    setIsOpen(false);
  };

  return (
    <div className="tenant-selector">
      <button 
        className="tenant-selector-button"
        onClick={() => setIsOpen(!isOpen)}
        disabled={tenantLoading}
      >
        <Building2 size={16} />
        <span className="tenant-name">
          {tenantLoading ? 'Loading...' : (currentTenant?.name || 'Select Tenant')}
        </span>
        <ChevronDown size={14} className={`chevron ${isOpen ? 'open' : ''}`} />
      </button>

      {isOpen && (
        <div className="tenant-dropdown">
          <div className="tenant-dropdown-header">
            Switch Tenant
          </div>
          {tenants.map(tenant => (
            <button
              key={tenant.id}
              className={`tenant-option ${tenant.id === currentTenant?.id ? 'active' : ''}`}
              onClick={() => handleSelect(tenant.id)}
            >
              <div className="tenant-option-info">
                <span className="tenant-option-name">{tenant.name}</span>
                <span className="tenant-option-role">{tenant.role?.replace('_', ' ')}</span>
              </div>
              {tenant.id === currentTenant?.id && <Check size={14} />}
            </button>
          ))}
          {isPlatformAdmin() && (
            <div className="tenant-dropdown-footer">
              <span className="platform-admin-badge">Platform Admin</span>
            </div>
          )}
        </div>
      )}

      {/* Click outside to close */}
      {isOpen && <div className="tenant-backdrop" onClick={() => setIsOpen(false)} />}
    </div>
  );
}
